<template>
  <div>
    <div class="columns">
      <page-header title="Detalle pedidos fuera de meta"></page-header>
    </div>

    <filtros @change="changeFiltersHandle"></filtros>
    <section>
      <div class="columns">
        <div class="column is-5 filter-container">
          <b-field label="Zona" class="is-pulled-left">
            <b-select v-model="zona" placeholder="Seleccione una zona...">
              <option
                v-for="item in zonas"
                :key="`zona-${item.id}`"
                :value="item.id"
              >
                {{ item.nombre }}
              </option>
            </b-select>
          </b-field>
          <b-field label="Tipo Meta" class="is-pulled-left ml-3">
            <b-radio-button
              v-model="esMetaPromedio"
              :native-value="true"
              type="is-primary is-light is-outlined"
            >
              <span>Meta Promedio</span>
            </b-radio-button>
            <b-radio-button
              v-model="esMetaPromedio"
              :native-value="false"
              type="is-primary is-light is-outlined"
            >
              <span>Meta Tope</span>
            </b-radio-button>
          </b-field>
          <div class="is-pulled-left ml-3 mb-3">
            <b-button
              type="is-success"
              icon-left="file-excel"
              :disabled="isExportDisabled"
              @click="exportDataset"
            >
              Exportar
            </b-button>
          </div>
        </div>
        <div class="column">
          <b-field label="Columnas">
            <div class="block">
              <b-checkbox
                v-for="item in columnasDisponibles"
                :key="`col-selector-${item.id}`"
                v-model="columnas"
                :native-value="item.id"
              >
                {{ item.nombreLargo || item.nombre }}
              </b-checkbox>
            </div>
          </b-field>
        </div>
      </div>
      <div class="columns">
        <div class="column is-12">
          <table>
            <tr>
              <th
                v-for="item in columnasVisibles"
                :key="`column-title-${item.orden}`"
                class="center header"
                :style="`width: ${item.ancho}`"
              >
                {{ item.nombre }}
              </th>
            </tr>
            <tr v-for="(item, index) in pedidos" :key="`pedidos-line-${index}`">
              <td
                v-for="cell in columnasVisibles"
                :key="`pedidos-line-cell-${cell.orden}`"
                :class="cell.clase"
              >
                {{ item[cell.id] }}
              </td>
            </tr>
            <tr v-if="pedidos.length === 0">
              <td :colspan="columnasVisibles.length">
                <strong>No se han cargado datos!</strong>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { format } from 'date-fns'

import { dashboardService, zonaService } from '@/services'
import Filtros from '@/components/dashboard/Filtros.vue'
import PageHeader from '@/components/shared/PageHeader.vue'

export default {
  name: 'TiemposPorZona',
  components: {
    Filtros,
    PageHeader
  },
  data() {
    return {
      desde: null,
      hasta: null,
      pedidos: [],
      esMetaPromedio: true,
      zonas: [],
      zona: null,
      timer: null,
      columnas: [],
      columnasDisponibles: [
        {
          id: 'ordenVenta',
          orden: 1,
          visible: true,
          clase: 'center',
          ancho: '4%',
          nombre: 'Orden Venta'
        },
        {
          orden: 2,
          id: 'tipoVenta',
          visible: false,
          clase: 'center',
          ancho: '8%',
          nombre: 'Tipo Venta'
        },
        {
          orden: 3,
          id: 'tipoPedido',
          visible: false,
          clase: 'center',
          ancho: '5%',
          nombre: 'Tipo Pedido'
        },
        {
          orden: 4,
          id: 'cliente',
          visible: true,
          clase: '',
          ancho: '18%',
          nombre: 'Cliente'
        },
        {
          orden: 5,
          id: 'pickeador',
          visible: true,
          clase: '',
          ancho: '18%',
          nombre: 'Pickeador'
        },
        {
          orden: 6,
          id: 'nroItems',
          visible: true,
          clase: 'center',
          ancho: '2.95%',
          nombre: 'Nº Items'
        },
        {
          orden: 7,
          id: 'cantidad',
          visible: true,
          clase: 'center',
          ancho: '2.95%',
          nombre: 'Cant.',
          nombreLargo: 'Cantidad'
        },
        {
          orden: 8,
          id: 'tiempoAsignacion',
          visible: true,
          clase: 'center',
          ancho: '4.5%',
          nombre: 'Tº Asigna',
          nombreLargo: 'Tº Asignación'
        },
        {
          orden: 9,
          id: 'tiempoPicking',
          visible: true,
          clase: 'center header',
          ancho: '4.5%',
          nombre: 'Tº Pickin',
          nombreLargo: 'Tº Picking'
        },
        {
          orden: 10,
          id: 'tiempoDespacho',
          visible: true,
          clase: 'center header',
          ancho: '4.5%',
          nombre: 'Tº Despac',
          nombreLargo: 'Tº Despacho'
        },
        {
          orden: 11,
          id: 'tiempoTotal',
          visible: true,
          clase: 'center header',
          ancho: '4.5%',
          nombre: 'Tº Total'
        },
        {
          orden: 12,
          id: 'horaFacturaAnticipo',
          visible: true,
          clase: 'center header',
          ancho: '6.9%',
          nombre: 'Hora F. Anticipo'
        },
        {
          orden: 13,
          id: 'horaAsignacion',
          visible: true,
          clase: 'center header',
          ancho: '6.9%',
          nombre: 'Hora Asignación'
        },
        {
          orden: 14,
          id: 'horaPicking',
          visible: false,
          clase: 'center header',
          ancho: '6.9%',
          nombre: 'Hora Picking'
        },
        {
          orden: 15,
          id: 'horaDespacho',
          visible: false,
          clase: 'center header',
          ancho: '6.9%',
          nombre: 'Hora Despacho'
        },
        {
          orden: 16,
          id: 'vendedor',
          visible: false,
          clase: 'center header',
          ancho: '10%',
          nombre: 'Vendedor'
        }
      ],
      downloading: false
    }
  },
  computed: {
    ...mapGetters('sesion', ['bodega']),
    columnasVisibles() {
      return this.columnasDisponibles.filter((item) => item.visible)
    },
    isExportDisabled() {
      if (this.downloading) return true
      return this.pedidos.length === 0
    }
  },
  watch: {
    zona() {
      this.getDashboardData()
    },
    esMetaPromedio() {
      this.getDashboardData()
    },
    columnas(newValue) {
      this.columnasDisponibles = this.columnasDisponibles.map((item) =>
        Object.assign(item, { visible: newValue.includes(item.id) })
      )
    }
  },
  beforeDestroy() {
    this.removeTimer()
  },
  mounted() {
    this.getZonas().then((_) => {
      this.zona = this.zonas[0].id
      this.getDashboardData()
    })
    this.columnas = this.columnasDisponibles.map((item) => {
      if (item.visible) return item.id
    })
  },
  methods: {
    changeFiltersHandle(payload) {
      this.desde = payload.desde
      this.hasta = payload.hasta
      this.getDashboardData()
    },
    async getDashboardData() {
      try {
        if (!this.zona) return
        const parametros = {
          zona: this.zona,
          esMetaPromedio: this.esMetaPromedio
        }
        if (!this.desde || !this.hasta) {
          this.desde = new Date()
          this.hasta = new Date()
        }
        this.removeTimer()
        const rs = await dashboardService.getDashboardDataset(
          4,
          this.bodega.id,
          this.desde,
          this.hasta,
          parametros
        )
        this.pedidos = rs.data
        this.timer = setInterval(() => this.getDashboardData(), 5 * 60000)
      } catch (e) {
        this.procesarError(e)
      }
    },
    removeTimer() {
      if (this.timer !== null) clearInterval(this.timer)
    },
    async getZonas() {
      await zonaService
        .getZonasByBodega(this.bodega.id)
        .then((response) => (this.zonas = response.data))
    },
    async exportDataset() {
      this.downloading = true
      try {
        if (!this.zona) return
        const parametros = {
          zona: this.zona,
          esMetaPromedio: this.esMetaPromedio
        }
        if (!this.desde || !this.hasta) {
          this.desde = new Date()
          this.hasta = new Date()
        }
        const blob = await dashboardService.exportarDataset(
          5,
          this.bodega.id,
          this.desde,
          this.hasta,
          parametros
        )
        const timestamp = format(new Date(), 'yyyyMMddHHmm')
        const file = window.URL.createObjectURL(new Blob([blob.data]))
        const docUrl = document.createElement('a')
        docUrl.href = file
        docUrl.setAttribute('download', `datos_dashboard_${timestamp}.xlsx`)
        document.body.appendChild(docUrl)
        docUrl.click()
        window.URL.revokeObjectURL(docUrl.href)
        document.body.removeChild(docUrl)
      } catch (error) {
        this.procesarError(error)
      }
      this.downloading = false
    }
  }
}
</script>

<style lang="scss" scoped>
.center {
  text-align: center;
}

.right {
  text-align: right;
}

table {
  th.header,
  td {
    border: 1px solid #000;
    padding: 2px 6px;
  }
  td.td-gap {
    border-top: none;
    border-bottom: none;
    &:last-child {
      border-right: none;
    }
  }
}

.filter-container {
  display: flex;
  align-items: flex-end;
}
</style>
